import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import api from '../utils/api';
import moment from 'moment';
import './styles/SppPaymentPage.css'; // Adjust the path as necessary
import { generatePaymentReceiptPDF } from './util/paymentReceipt';

import { useNavigate } from 'react-router-dom';

const SppPaymentPage = ({ isSidebarCollapsed }) => {
    const { studentId } = useParams();
    const [student, setStudent] = useState(null);
    const [paymentMonths, setPaymentMonths] = useState(0);
    const [paymentDate, setPaymentDate] = useState(moment().format('YYYY-MM-DD'));
    const [paymentDetails, setPaymentDetails] = useState([]);
    const navigate = useNavigate();
    const [errors, setErrors] = useState({}); // Untuk menyimpan pesan error
    const [paymentMethod, setPaymentMethod] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        const fetchStudentDetails = async () => {
            try {
                const response = await api.get(`/payment/sppPayment/${studentId}`);
                setStudent(response.data?.data[0] || null);
            } catch (error) {
                console.error("Failed to fetch student details", error);
            }
        };
        fetchStudentDetails();
    }, [studentId]);

    const handlePaymentMonthsChange = (e) => {
        const value = parseInt(e.target.value);
        if (value > 0) {
            setPaymentMonths(value);
            generatePaymentDetails(value);
        } else {
            setPaymentMonths(0);
            setPaymentDetails([]);
        }
    };

    const generatePaymentDetails = (months) => {
        const costs = student.StudentLevels[0].mainProgram.Costs;
        let addonCosts = [];
        if(student.StudentLevels[0].addonProgram != null){
            addonCosts = student.StudentLevels[0].addonProgram.Costs;
        }
        const lastPayment = student.Payments[0].StudentPaymentHistories[0];
        const paymentMonth = lastPayment.payment_month;
        const paymentYear = lastPayment.payment_year;

        const details = [];
        let total = 0;

        for (let i = 0; i < months; i++) {
            const monthToPay = moment().month(paymentMonth + i).year(paymentYear + Math.floor((paymentMonth + i) / 12)).format('MMMM YYYY');
            const costItem = costs[0].cost_item; 
            let costAmount = parseFloat(costs[0].cost_amount);
            if(student.StudentLevels[0].addonProgram != null) {
                costAmount = parseFloat(costs[0].cost_amount) + parseFloat(addonCosts[0].cost_amount);
            }
            details.push({ item: `${costItem} Bulan ${monthToPay}`, amount: costAmount });
            total += costAmount;
        }

        setPaymentDetails(details);
    };

    const calculateTotalAmount = () => {
        return paymentDetails.reduce((sum, detail) => sum + detail.amount, 0);
    };
    

    const validateForm = (formData) => {
        const errors = {};
    
        // Cek jika field kosong
        if (formData.paymentMonths < 1) errors.paymentMonths = 'Payment For is required';
        if (!formData.paymentDate) errors.paymentDate = 'Payment Date is required';
        if (!formData.paymentMethod) errors.paymentMethod = 'Payment Method is required';
    
        return errors;
    };

    const simulateProgress = (onComplete) => {
        setProgress(0);
        let percent = 0;
        const interval = setInterval(() => {
            percent += Math.random() * 10;
            if (percent >= 100) {
                clearInterval(interval);
                setProgress(100);
                if (typeof onComplete === 'function') {
                   const run = () => {
                        try {
                            const maybePromise = onComplete();
                            if (maybePromise?.catch) {
                                maybePromise.catch(err => console.error('simulateProgress task error', err));
                            }
                        } catch (err) {
                            console.error('simulateProgress task error', err);
                        }
                    };
                    if (typeof window !== 'undefined' && typeof window.requestAnimationFrame === 'function') {
                        window.requestAnimationFrame(run);
                    } else {
                        setTimeout(run, 0);
                    }
                }
            } else {
                setProgress(Math.min(99, Math.floor(percent)));
            }
        }, 100);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
    
        const formData = {
          paymentMonths: e.target.paymentMonths.value,
          paymentDate: e.target.paymentDate.value,
          paymentMethod: e.target.paymentMethod.value
        };

        const totalAmount = calculateTotalAmount();
    
        const validationErrors = validateForm(formData);
    
        if (Object.keys(validationErrors).length > 0) {
          // Jika ada error, set state errors untuk menampilkan pesan error
          setErrors(validationErrors);
          console.log('Validation Errors:', validationErrors);
        } else {
            const confirmation = window.confirm('Are you sure you want to proceed with this action?');
            if (!confirmation) {
                return;
            }

            const requestBody = {
                data: {
                    paymentData: {
                        student_id: studentId,
                        payment_date: formData.paymentDate, 
                        payment_for: formData.paymentMonths, 
                        payment_method: formData.paymentMethod,  
                        payment_amount: totalAmount,   
                        program_id: student.StudentLevels[0].mainProgram.program_id,  
                        addon_program_id: student.StudentLevels[0].addonProgram? student.StudentLevels[0].addonProgram.program_id: null,  
                    }
                }
            };
            
            setIsLoading(true);
            api.post('/payment/sppPaymentSave', requestBody)
            .then(() => {
                simulateProgress(async () => {
                    try {
                        await new Promise(resolve => {
                            if (typeof window !== 'undefined' && typeof window.requestAnimationFrame === 'function') {
                                window.requestAnimationFrame(() => resolve());
                            } else {
                                setTimeout(resolve, 0);
                            }
                        });

                        await generatePaymentReceiptPDF(student, formData, paymentDetails, paymentDate, 'SPP');
                        alert('Payment success!');
                    } catch (err) {
                        console.error('Failed to generate receipt', err);
                        alert('Payment tersimpan, tapi generate PDF gagal. Silakan hubungi administrator!');
                    } finally {
                        setIsLoading(false);
                        navigate(`/student/detail/${student.student_id}`);
                    }
                });
            })
             .catch(error => {
                setIsLoading(false);
                console.error('Error adding student:', error);
                navigate('/error', { state: { message: 'Please ask to administrator!' } });
             });
        }
    };

    const handleTestGeneratePDF = () => {
        const paymentMethodValue = document.getElementById('paymentMethod')?.value;
        const paymentDateValue = document.getElementById('paymentDate')?.value;
      
        if (!student || !paymentDetails.length || !paymentDateValue) {
          alert(paymentDetails.length);
          alert(student);
          alert(paymentDateValue);
          alert('Data pembayaran belum lengkap!');
          return;
        }
      
        const tempFormData = {
          paymentMethod: paymentMethodValue,
        };
      
        generatePaymentReceiptPDF(student, tempFormData, paymentDetails, paymentDateValue);
      };
      
      
      

    if (!student) return <p>Loading student details...</p>;

    return (
        <div className={`page-content ${isSidebarCollapsed ? 'collapsed' : ''} spp-payment`}>
            <div className="page-title">SPP Payment</div>
            <div className="form-container">
                <form onSubmit={handleSubmit}>
                    <div className="section">
                        <h3 className="section-header">Student Data</h3>
                        <table>
                            <tbody>
                                <tr>
                                    <td>Name</td>
                                    <td>:</td>
                                    <td>{student.student_name}</td>
                                </tr>
                                <tr>
                                    <td>NIK</td>
                                    <td>:</td>
                                    <td>{student.student_code}</td>
                                </tr>
                                <tr>
                                    <td>Program</td>
                                    <td>:</td>
                                    <td>{student.StudentLevels[0].mainProgram.program_name}</td>
                                </tr>
                                <tr>
                                    <td>Level</td>
                                    <td>:</td>
                                    <td>{student.StudentLevels[0].Level.level_name}</td>
                                </tr>
                                <tr>
                                    <td>Last SPP Payment</td>
                                    <td>:</td>
                                    <td>{moment().month(student.Payments[0].StudentPaymentHistories[0].payment_month-1).year(student.Payments[0].StudentPaymentHistories[0].payment_year).format('MMMM YYYY')}</td>
                                </tr>
                                <tr>
                                    <td>Last Payment Date</td>
                                    <td>:</td>
                                    <td>{moment(student.Payments[0].payment_date).format('DD MMMM YYYY')}</td>
                                </tr>
                                <tr>
                                    <td>Payment For</td>
                                    <td>:</td>
                                    <td>
                                        <div>
                                            <input
                                                type="number"
                                                name="paymentMonths"
                                                value={paymentMonths}
                                                onChange={handlePaymentMonthsChange}
                                                min="1"
                                                placeholder="0"
                                                className="input-months"
                                            />
                                            <span>month(s)</span>
                                        </div>
                                    </td>
                                </tr>
                                {errors.paymentMonths && <div className="error-message">{errors.paymentMonths}</div>}
                                <tr>
                                    <td>Payment Date</td>
                                    <td>:</td>
                                    <td>
                                        <input
                                            type="date"
                                            name="paymentDate"
                                            value={paymentDate}
                                            id="paymentDate"
                                            onChange={(e) => setPaymentDate(e.target.value)}
                                            className="input-date"
                                        />
                                    </td>
                                </tr>
                                {errors.paymentDate && <div className="error-message">{errors.paymentDate}</div>}
                                <tr>
                                    <td>Payment Method</td>
                                    <td>:</td>
                                    <td>
                                        <select name="paymentMethod"
                                        id="paymentMethod"
                                        value={paymentMethod}
                                        onChange={(e) => setPaymentMethod(e.target.value)}>
                                            <option key="" value="">Choose Payment Method</option>
                                            <option key="BANK BCA" value="BANK BCA">BANK BCA</option>
                                            <option key="BANK BRI" value="BANK BRI">BANK BRI</option>
                                        </select>
                                    </td>
                                </tr>
                                {errors.paymentMethod && <div className="error-message">{errors.paymentMethod}</div>}
                            </tbody>
                        </table>
                    </div>
                    {paymentDetails.length > 0 && (
                        <div className="create-student-table">
                            <h3>Payment Details</h3>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Pembayaran</th>
                                        <th>Price</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {paymentDetails.map((detail, index) => (
                                        <tr key={index}>
                                            <td>{detail.item}</td>
                                            <td>{detail.amount.toLocaleString('id-ID')}</td>
                                        </tr>
                                    ))}
                                    <tr>
                                        <td><strong>Total Pembayaran</strong></td>
                                        <td><strong>{calculateTotalAmount().toLocaleString('id-ID')}</strong></td>
                                        
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    )}
                    <div className="button-group-profile">
                        <button className="profile-button" type="submit">Payment</button>  
                        <button className="profile-button" onClick={() => navigate(`/student-details/${student.student_id}`)}>Back</button>
                    </div>
                </form>
                
                
            </div>
            {isLoading && (
            <div className="progress-overlay">
                <div className="progress-container">
                <div className="progress-bar" style={{ width: `${progress}%` }} />
                <div className="progress-text">{progress}%</div>
                </div>
            </div>
            )}
        </div>
    );
};

export default SppPaymentPage;
